import {
  Grid,
  RACButton,
  RACModalCard,
  Typography,
} from '@rentacenter/racstrap';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { ReactComponent as Success } from '../../Assets/Icons/Done.svg';
import { ReturnCheckStyles } from '../../JsStyles/ReturnCheckStyles';
import { CreditCardContext } from '../CreditcardChargeback/CreditcardContext';

export default function VerifiedPopup(props?: any) {
  const classes = ReturnCheckStyles();
  const history = useHistory();
  const hasFunction = props && props?.setFunction ? true : false;
  const { setFooter, setDisplaySearch } = useContext(CreditCardContext);

  return (
    <RACModalCard
      isOpen={true}
      closeIcon={true}
      maxWidth="xs"
      borderRadius="25px !important"
      className={`${classes.infoPopup}`}
      onClose={() => {
        props?.isCancel ? setDisplaySearch(true) : null;
        hasFunction ? props.setFunction(false) : history.goBack();
        props?.fetchCreditcardSearchData
          ? props?.fetchCreditcardSearchData()
          : setFooter(true);
      }}
    >
      <div
        id="processed"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid className={classes.centerAlign}>
          <Success />
          <Typography variant="h6" className={`  ${classes.mt2}`}>
            {props.message}
          </Typography>
        </Grid>
        <Grid
          item
          md={12}
          className={`${classes.mt3} ${classes.pb4} ${classes.centerAlign}`}
        >
          <RACButton
            className={classes.mlr1}
            variant="contained"
            color="primary"
            onClick={() => {
              props?.isCancel ? setDisplaySearch(true) : null;
              props?.setState ? props.setState(true) : null;
              hasFunction ? props.setFunction(false) : history.goBack();
              props?.fetchCreditcardSearchData
                ? props?.fetchCreditcardSearchData()
                : setFooter(true);
            }}
          >
            OK
          </RACButton>
        </Grid>
      </div>
    </RACModalCard>
  );
}
